import { Controller } from "@hotwired/stimulus";

// The native popover escapes account-table overflow and owns Escape/light dismissal.
export default class AccountTooltipController extends Controller<HTMLElement> {
  static targets = ["trigger", "help"];
  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly helpTarget: HTMLElement;
  private pinned = false;

  show() {
    if (this.helpTarget.matches(":popover-open")) return;
    this.helpTarget.showPopover();
    const trigger = this.triggerTarget.getBoundingClientRect();
    const help = this.helpTarget.getBoundingClientRect();
    const left = Math.max(8, Math.min(trigger.left, window.innerWidth - help.width - 8));
    const top = trigger.bottom + help.height + 8 <= window.innerHeight
      ? trigger.bottom : Math.max(8, trigger.top - help.height);
    this.helpTarget.style.left = `${left}px`;
    this.helpTarget.style.top = `${top}px`;
  }

  toggle() {
    if (this.pinned) this.dismiss();
    else {
      this.show();
      this.pinned = true;
    }
  }

  leave(event: PointerEvent) {
    if (event.relatedTarget instanceof Node && this.element.contains(event.relatedTarget)) return;
    if (!this.pinned && document.activeElement !== this.triggerTarget) this.dismiss();
  }

  dismiss() {
    this.helpTarget.hidePopover();
    this.pinned = false;
  }

  beforeToggle(event: ToggleEvent) {
    if (event.newState === "closed") this.pinned = false;
  }
}
